"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPlayerOffer = exports.FeedType = exports.OfferFeedProperty = exports.KeskoOfferFeedProperty = void 0;
var KeskoOfferFeedProperty;
(function (KeskoOfferFeedProperty) {
    KeskoOfferFeedProperty["id"] = "id";
    KeskoOfferFeedProperty["name"] = "name";
    KeskoOfferFeedProperty["info"] = "info";
    KeskoOfferFeedProperty["description"] = "description";
    KeskoOfferFeedProperty["category"] = "category";
    KeskoOfferFeedProperty["salePrice"] = "salePrice";
    KeskoOfferFeedProperty["salesPrice"] = "salesPrice";
    KeskoOfferFeedProperty["price"] = "price";
    KeskoOfferFeedProperty["store"] = "store";
    KeskoOfferFeedProperty["brand"] = "brand";
    KeskoOfferFeedProperty["validFrom"] = "validFrom";
    KeskoOfferFeedProperty["visibleTo"] = "visibleTo";
    KeskoOfferFeedProperty["deeplink"] = "deeplink";
    KeskoOfferFeedProperty["salesUnit"] = "salesUnit";
    KeskoOfferFeedProperty["productIds"] = "productIds";
    KeskoOfferFeedProperty["imageUrl"] = "imageUrl";
    KeskoOfferFeedProperty["fileMetadata"] = "fileMetadata";
    // boolean
    KeskoOfferFeedProperty["isPlusOffer"] = "isPlusOffer";
})(KeskoOfferFeedProperty = exports.KeskoOfferFeedProperty || (exports.KeskoOfferFeedProperty = {}));
/**
 * Properties used in feed condtions
 */
var OfferFeedProperty;
(function (OfferFeedProperty) {
    OfferFeedProperty["brand"] = "brand";
    OfferFeedProperty["category"] = "category";
})(OfferFeedProperty = exports.OfferFeedProperty || (exports.OfferFeedProperty = {}));
var FeedType;
(function (FeedType) {
    FeedType["offers"] = "offers";
    FeedType["newProducts"] = "newProducts";
    FeedType["recipes"] = "recipes";
})(FeedType = exports.FeedType || (exports.FeedType = {}));
exports.isPlayerOffer = (product) => product.id && product.category;
//# sourceMappingURL=feeds.js.map